export const getVersionlessApp = (app: string) => app.split('@')[0];

export default getVersionlessApp;
